import {Margin} from "./margin";
import {Position} from "./position";
import {Size} from "./size";
import {BoundingBox} from "./boundingBox.ts";

export class Box {
	position: Position;
	size: Size;
	margin: Margin;

	constructor(position?: Position, size?: Size, margin?: Margin) {
		this.position = position || new Position();
		this.size = size || new Size();
		this.margin = margin || new Margin();
	}

	getBoundingBox(): BoundingBox {
		return {
			x: this.position.x + this.margin.left,
			y: this.position.y + this.margin.top,
			width: this.size.width - this.margin.left - this.margin.right,
			outerWidth: this.size.width + this.margin.left + this.margin.right,
			height: this.size.height - this.margin.top - this.margin.bottom,
			outerHeight: this.size.height + this.margin.top + this.margin.bottom
		};
	}
}
